import styled from 'styled-components'
// features
// import { ClaimDetailsPatient } from 'features/claims/components'
import { IClaim } from 'features/claims/types'
import { ClaimDetailsCalls } from './ClaimDetailsCalls'
import { ClaimDetailsHistoryAndComments } from './ClaimDetailsHistoryAndComments'

import { getClaimDetailPath } from 'features/claims/utils/claimsPathUtils'
import { toNumber } from 'lodash'
import { useLayoutEffect, useRef, useState } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { getTntIdForNavigation } from 'utils/tenantUrlUtils'
import { Button } from '@outbound-ai/ursa'
import { getCurrentWindowInnerHeight } from 'utils/Utils'
import { CallInsight } from './CallInsight'
import { ProviderRecord } from './ProviderRecord/ProviderRecord'

interface IClaimDetailsProps {
  claim: IClaim
  slotData?: any
}

export const ClaimDetails = ({ claim, slotData }: IClaimDetailsProps) => {
  const [callInsightHeight, setCallInsightHeight] = useState(0)
  const [payerWrapperWidth, setPayerWrapperWidth] = useState(0)
  const [historyHeight, setHistoryHeight] = useState(0)
  const providerWrapperRef = useRef(null as any)
  const callsWrapperRef = useRef(null as any)
  const payerWrapperRef = useRef(null as any)

  const windowHeight = getCurrentWindowInnerHeight()
  const navigate = useNavigate()

  const oaiClaimIds = JSON.parse(localStorage.getItem('oaiClaimIds')!)

  const lastId = toNumber(window.location.href.split('/').pop())

  const navigatePage = (direction: string) => {
    const selectedRow = JSON.parse(localStorage.getItem('oaiClaimId')!)
    const currentIndex = oaiClaimIds.indexOf(selectedRow)
    const tenantId = getTntIdForNavigation()
    if (direction === 'previous') {
      if (currentIndex > 0) {
        const previousClaimId = oaiClaimIds[currentIndex - 1]
        localStorage.setItem('oaiClaimId', JSON.stringify(previousClaimId))
        const claimDetailPath = getClaimDetailPath(tenantId, previousClaimId)
        navigate(claimDetailPath)
      }
    } else if (direction === 'next') {
      if (currentIndex < oaiClaimIds.length - 1) {
        const nextClaimId = oaiClaimIds[currentIndex + 1]
        localStorage.setItem('oaiClaimId', JSON.stringify(nextClaimId))
        const claimDetailPath = getClaimDetailPath(tenantId, nextClaimId)
        navigate(claimDetailPath)
      }
    }
  }

  useLayoutEffect(() => {
    const providerWrapperHeight = providerWrapperRef.current?.clientHeight
    const callInsightHeight = windowHeight - providerWrapperHeight - 87
    setCallInsightHeight(callInsightHeight)

    const callWrapperHeight = providerWrapperRef.current?.clientHeight
    const historyHeight = windowHeight - callWrapperHeight - 145
    setHistoryHeight(historyHeight)

    const payerWrapper = payerWrapperRef.current?.clientWidth
    setPayerWrapperWidth(payerWrapper)
  }, [callInsightHeight])

  return (
    <>
      <Div historyHeight={historyHeight} callInsightHeight={callInsightHeight} payerWrapperWidth={payerWrapperWidth}>
        <div className="left-claim-detail-wrapper">
          <div className="provider-wrapper" ref={providerWrapperRef}>
            <ProviderRecord slotData={slotData} />
          </div>
          <div className="payer-call-wrapper" ref={payerWrapperRef} style={{ height: `${callInsightHeight}px` }}>
            <CallInsight claim={claim} slotData={slotData} />
          </div>
        </div>
        <div className="right-claim-detail-wrapper">
          <div className="calls-wrapper" ref={callsWrapperRef}>
            <ClaimDetailsCalls claim={claim} />
          </div>
          <div className="historyAndComments" style={{ height: `${historyHeight}px` }}>
            <ClaimDetailsHistoryAndComments claim={claim} />
          </div>
        </div>
      </Div>
      {oaiClaimIds?.includes(lastId!) && (
        <Pagination>
          <span>Claim {oaiClaimIds.indexOf(claim.claimId) + 1} of Claims list </span>

          <Button
            variant="secondary"
            radius="rounded"
            width="32px"
            onClick={() => {
              navigatePage('previous')
            }}
            disabled={oaiClaimIds.indexOf(claim.claimId) === 0}
          >
            <FaChevronLeft />
          </Button>
          <Button
            variant="secondary"
            radius="rounded"
            width="32px"
            onClick={() => {
              navigatePage('next')
            }}
            disabled={oaiClaimIds.indexOf(claim.claimId) === oaiClaimIds.length - 1}
          >
            <FaChevronRight />
          </Button>
        </Pagination>
      )}
    </>
  )
}

const Pagination = styled.div`
  position: fixed;
  bottom: ${({ theme }) => theme.spacing.s};
  right: ${({ theme }) => theme.spacing.s};
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
  background-color: ${({ theme }) => theme.colors.neutral.lightest};
  border: none;
  display: flex;
  padding: ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.xxs};
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border: 1px solid ${({ theme }) => theme.colors.grey.lighter};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s ease;
  gap: ${({ theme }) => theme.spacing.xxs};
  span {
    color: ${({ theme }) => theme.colors.primary.neutral};
    ${({ theme }) => theme.typography.xs.medium};
  }
`

const Div = styled.div<{ historyHeight: number; callInsightHeight: number; payerWrapperWidth: number }>`
  display: flex;

  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }
  .left-claim-detail-wrapper {
    width: 80%;
    margin-right: 1rem;
    .provider-wrapper {
      margin-bottom: 1rem;
      .tooltip-container {
        width: auto;
        max-width: fit-content;
      }
    }
    .payer-call-wrapper {
      .react-tabs {
        height: 100%;
      }
      .react-tabs__tab-panel {
        position: relative;
      }
      .extracted-details {
        height: ${({ callInsightHeight }) => callInsightHeight - 85 + 'px'};
        overflow: auto;
        overflow-x: hidden;
      }
      .claim-details-add {
        width: ${({ payerWrapperWidth }) => payerWrapperWidth - 30 + 'px'};
      }
      .network-container {
        height: ${({ callInsightHeight }) => callInsightHeight - 128 + 'px'};
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 0.625rem;
      }
    }
  }
  .right-claim-detail-wrapper {
    width: 20%;
    .calls-wrapper {
      margin-bottom: 1rem;
    }
  }
  .historyAndComments {
    .react-tabs {
      height: ${({ historyHeight }) => historyHeight + 'px'};
      overflow: hidden;
      .history-inside-container {
        height: ${({ historyHeight }) => historyHeight - 110 + 'px'};
      }
    }
    /* .react-tabs__tab-panel {
      height: ${({ historyHeight }) => historyHeight + 'px'};
      overflow: auto;
    } */
    .infinite-scroll-component {
      height: auto !important;
      overflow: hidden !important;
    }
  }
`
